<template>
  <tr>
    <td data-label="Fecha/Hora">{{ log.createdAt }}</td>
    <td data-label="Usuario">
      <div class="user">
        <span v-if="log.user">{{ log.user.email }}</span>
        <span v-if="log.organization" class="user-entity">{{ log.organization.businessName }}</span>
      </div>
    </td>
    <td data-label="IP">{{ log.ip }}</td>
    <td data-label="Dispositivo">{{ log.userAgent }}</td>
    <td data-label="Ruta"><strong>{{ log.action }}</strong> {{ log.referer }}</td>
    <td data-label="Parámetros">
      <span class="infotip top" :class="{'active' : showParams}">
        <button class="infotip__host" aria-controls="infotip-overlay" aria-expanded="true" aria-label="Help" type="button" @click="showParams = !showParams">
          <div class="log-params">
            {{ log.body }}
          </div>
        </button>
        <span class="infotip__live-region" aria-live="off">
          <div class="infotip__overlay" id="infotip-overlay">
            <h4>Parámetros</h4>
            <div class="code">
              {{ log.body }}
            </div>
          </div>
        </span>
      </span>
    </td>
  </tr>
</template>

<script>
export default {
  name: 'audit-logs-row',
  props: {
    log: {
      type: Object,
      required: true
    },
  },
  data () {
    return {
      showParams: false
    }
  },
  created() {
    window.addEventListener('click', this.close)
  },
  beforeDestroy() {
    window.removeEventListener('click', this.close)
  },
  methods: {
    close (e) {
      if (! this.$el.contains(e.target)) {
        this.showParams = false
      }
    }
  }
}
</script>
